/**
 * Undo plumbing for the Pages panel's gestures. The actions themselves (page
 * edits, presets, shared children) live in `trace-viewer/editor` and return
 * their commands; these push them.
 */

import { getUndoManager, CompositeCommand } from 'trace-viewer/editor';
import type { UndoCommand } from 'trace-viewer/editor';
import { showToast } from '../toast';

/** Push `command` as one undo entry, unless it is null or an undo or redo is replaying by then. */
export function pushCommand(command: UndoCommand | null): void {
    if (command && !getUndoManager().isUndoRedoing) getUndoManager().push(command);
}

/** Push `commands` as one undo entry labelled `label`, unless an undo or redo is replaying. */
export function pushBundle(label: string, commands: UndoCommand[]): void {
    pushCommand(commands.length === 1 ? commands[0] : new CompositeCommand(label, commands));
}

/** Push a page edit's command; a refusal is shown as a toast, and pushes nothing. */
export function pushOp(result: { command: UndoCommand } | { refused: { message: string } } | null): void {
    if (!result) return;
    if ('refused' in result) showToast(result.refused.message, 'error');
    else pushCommand(result.command);
}
